import { useNavigate } from 'react-router-dom';
import type { TrophySet } from '@plathunt/types';

/**
 * Versionswechsel innerhalb desselben Games.
 *
 * Das Game bleibt dasselbe, nur das Trophy Set wechselt – und damit Trophy
 * Groups, Trophäenliste, Platin und Completion. Sets werden niemals
 * zusammengefuehrt: jede Plattform und jede Region bleibt eine eigene Zeile
 * mit eigenem Fortschritt.
 */
export function SetSwitcher({
  gameId,
  sets,
  activeSetId,
}: {
  gameId: string;
  sets: TrophySet[];
  activeSetId: string;
}) {
  const navigate = useNavigate();
  if (sets.length < 2) return null;

  const active = sets.find((set) => set.id === activeSetId);

  return (
    <details className="ph-switcher">
      <summary className="ph-switcher__summary">
        <span className="ph-switcher__label">Version</span>
        <span className="ph-switcher__current">
          {active ? `${active.platform.toUpperCase()} · ${active.region.toUpperCase()}` : 'wählen'}
        </span>
        <span className="ph-switcher__count">{sets.length} Versionen</span>
      </summary>

      <ul className="ph-switcher__list">
        {sets.map((set) => {
          const isActive = set.id === activeSetId;
          return (
            <li key={set.id}>
              <button
                type="button"
                className={`ph-switcher__item${isActive ? ' is-active' : ''}`}
                aria-current={isActive ? 'true' : undefined}
                onClick={() => navigate(`/game/${gameId}/set/${set.id}`)}
              >
                <span className="ph-switcher__item-title">{set.title}</span>
                <span className="ph-switcher__item-meta">
                  {set.platform.toUpperCase()} · {set.region.toUpperCase()}
                  {set.version ? ` · v${set.version}` : ''} · {set.trophyCount.total} Trophäen
                  {set.hasPlatinum ? ' · Platin' : ''}
                </span>
              </button>
            </li>
          );
        })}
      </ul>

      <p className="ph-switcher__note">
        Jede Version hat einen eigenen Fortschritt. PS4, PS5 und regionale Fassungen werden nicht
        zusammengerechnet.
      </p>
    </details>
  );
}
